<template>
  <div id="pageRoot">
    <img
      src="/pages/img/album/assets_p1/titulo.svg"
      style="
        width: 650px;
        margin-left: 80px;
        margin-top: 60px;
        position: absolute;
        z-index: 2;
      "
    />
    <img
      src="/pages/img/album/assets_p1/zorrito.svg"
      style="
        width: 570px;
        margin-left: 20px;
        margin-top: 230px;
        position: absolute;
        z-index: 2;
      "
      class="bouncingItem"
    />
    <div
      class="textBubble"
      style="width: 500px; height: 230px; left: 542px; margin-top: 206px"
    >
      <div
        class="textContainer textBase center"
        style="width: 90%; height: 90%"
      >
        <p class="center" style="font-size: 33px">
          Para ir guardando<br />
          las que más te gustan,<br />
          para tenerlas cerca<br />
          al momento de escribir
        </p>
      </div>
      <img
        class="arrow left"
        src="/pages/img/general/textBubbleArrowLeft.svg"
        style="top: 220px; left: 90px"
      />
    </div>
    <img
      src="/pages/img/album/assets_p1/letras.svg"
      style="
        width: 620px;
        margin-left: 400px;
        margin-top: 20px;
        position: absolute;
        z-index: 0;
      "
      class="slideItem"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      videos: ["alb/Video 3.mp4"],
    };
  },
};
</script>